import React, { useState } from 'react';
import { Helmet } from 'react-helmet';

import Logo from 'components/misc/Logo';
import * as style from 'styles/components/utils/takeOverJersey.module.scss';

import headlineImage from '../../images/takeover/framat.svg';
import jerseyGroupImage from '../../images/takeover/jersey-group-02.jpg';
import jersey01 from '../../images/takeover/jersey-01.jpg';
import jersey02 from '../../images/takeover/jersey-02.jpg';
import jersey03 from '../../images/takeover/jersey-03.jpg';

const TakeOver = ({ takeoverConfig }) => {

    const youtubeVideoId = takeoverConfig.youtubeVideoId ? takeoverConfig.youtubeVideoId : null;

    const [isTakeOverActive, toggleTakeOver] = useState(true);

    function fakeNavigation() {
        toggleTakeOver(false);
        document.getElementById("seasonalTakeover").remove();
    }

    return (
        <div id="seasonalTakeover" className={style.takeOver__wrapper}>
            {isTakeOverActive &&
            <Helmet>
                <body data-modal-open="true" />
            </Helmet>
            }
            <div className={style.takeOver__logo}>
                <Logo black />
            </div>

            <div className={style.takeOver__closeWrapper}>
                <button type="button" onClick={() => fakeNavigation(false)}>Hammarbyfotboll.se</button>
            </div>

            <div className={style.takeOver__content}>

                <div className={style.takeOver__header}>
                    <img src={headlineImage} alt="Framåt mot härliga tider" />
                </div>
                {youtubeVideoId && (
                    <div className={style.takeOver__video}>
                        <div className={style.takeOver__embedWrapper}>
                            <iframe src={`https://www.youtube.com/embed/${youtubeVideoId}`} title="Hammarby Fotboll" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen />
                        </div>
                    </div>
                )}

                <div className={style.takeOver__readMore}>
                    <a href="https://www.hammarbyfotboll.se/nyheter/hammarby-fotbolls-matchstaell-2024">Allt om säsongens matchställ.</a>
                </div>

                <div className={style.takeOver__rowColumns}>
                    <div className={`${style.takeOver__column} ${style.takeOver__columnWide}`}>
                        <img src={jerseyGroupImage} alt="Framåt mot härliga tider" />
                    </div>

                    <div className={`${style.takeOver__column} ${style.takeOver__columnNarrow}`}>
                       <h2>Matchtröjan 2024</h2>
                       <p>
                       Årets matchställ är här! Kritstrecksränder mot vit hemmatröja och mörkgrön bortatröja, kompletteras av en grön walk-in jacket i årets matchkollektion.
                       </p>
                       <a className={style.takeOver__columnCta} href="https://www.hammarbyfotboll.se/nyheter/hammarby-fotbolls-matchstaell-2024">Läs mer om tröjan här</a>
                    </div>
                </div>

                <div className={style.takeOver__rowColumns}>
                    <div className={`${style.takeOver__column} ${style.takeOver__columnJersey}`}>
                        <div className={style.takeOver__columnJerseyCta}>
                            <a className={style.takeOver__columnCta} target="_blank" rel="noreferrer" href="https://www.intersport.se/products/1577705/01">Beställ tröjan</a>
                        </div>
                        <img src={jersey01} alt="Framåt mot härliga tider" />
                    </div>

                    <div className={`${style.takeOver__column} ${style.takeOver__columnJersey}`}>
                        <div className={style.takeOver__columnJerseyCta}>
                            <a className={style.takeOver__columnCta} target="_blank" rel="noreferrer" href="https://www.intersport.se/products/1577706/01">Beställ tröjan</a>
                        </div>
                        <img src={jersey02} alt="Framåt mot härliga tider" />
                    </div>

                    <div className={`${style.takeOver__column} ${style.takeOver__columnJersey}`}>
                        <div className={style.takeOver__columnJerseyCta}>
                            <span className={style.takeOver__columnCtaSoon}>Kommer snart</span>
                        </div>
                        <img src={jersey03} alt="Framåt mot härliga tider" />
                    </div>
                </div>

            </div>

        </div>
    );
};
export default TakeOver;
